import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  text-align: center;
`;

export const Title = styled.h4`
  margin-bottom: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.bottomAlert.color};
`;

export const Text = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.bottomAlert.color};
  margin-bottom: 68px;
`;

export const Close = styled(Button)`
  height: 56px;
  font-size: 16px;
  font-weight: 600;
`;
